import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';

const Tab3 = ({ Company, WorkOrder }) => {
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">More Information</p>
      </div>

      <div className="col-6 ">
        <div className={Company.Error ? `mb-3 errorborder` : `mb-3`}>
         <SelectSearch
  list={Company.Company_list}
  label="Company"
  getOptionLabel={(item) =>
    item.isNew ? "+ Create New Company" : item.name
  }
  getOptionValue={(item) => item.name}
  value={Company.select_Company}
  onChange={(val) => Company.setselect_Company(val)}
  createNewUrl="/master/company/create-Company"
  createNewLabel="Create New Company"
/>
         
        </div>
      </div>

      <div className="col-6">
       <div className={WorkOrder.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
            list={WorkOrder?.WorkOrder_list || []}
            style={{
              height: "38px",
              border: WorkOrder?.Error ? "1px solid red" : "",
            }}
            label="Work Order"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={WorkOrder?.select_WorkOrder || null}
            onChange={(val) => WorkOrder?.setselect_WorkOrder?.(val)}
          />
        </div>
      </div>
    </div>
  );
};

export default Tab3;